import { render, staticRenderFns } from "./DriverStatus.vue?vue&type=template&id=50702b10&scoped=true&"
import script from "./DriverStatus.vue?vue&type=script&lang=js&"
export * from "./DriverStatus.vue?vue&type=script&lang=js&"
import style0 from "./DriverStatus.vue?vue&type=style&index=0&id=50702b10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50702b10",
  null
  
)

export default component.exports